import type { StaticImageData } from "next/image";
import Image from "next/image";
import Link from "next/link";

import logoPic from "@/public/images/logo.svg";

export function LogoLink({ className }: { className?: string }) {
  return (
    <Link href="/" className={className}>
      <span className="sr-only">Audimee</span>
      <Image
        src={logoPic as StaticImageData}
        alt="Logo of Audimee"
        style={{ height: 40, width: "fit-content" }}
      />
    </Link>
  );
}
